export default __webpack_public_path__ + "static/media/defaultLogo.ce88f532.png";